import {
  Eye,
  FileText,
  Mail,
  Download,
  XCircle,
  type LucideIcon,
} from 'lucide-react';
import { DistributionAction, DistributionStatus } from '@/types/distribution';

export const ACTION_CONFIG: Record<
  DistributionAction,
  { icon: LucideIcon; label: string; destructive?: boolean }
> = {
  view_details: { icon: Eye, label: 'View Details' },
  generate_notices: { icon: FileText, label: 'Generate Notices' },
  send_notices: { icon: Mail, label: 'Send Notices' },
  download_notices: { icon: Download, label: 'Download Notices' },
  cancel: { icon: XCircle, label: 'Cancel Distribution', destructive: true },
};

export const DISTRIBUTION_STATUS_LABELS: Record<DistributionStatus, string> = {
  [DistributionStatus.DRAFT]: 'Draft',
  [DistributionStatus.COMPLETED]: 'Completed',
  [DistributionStatus.CANCELLED]: 'Cancelled',
};

export const DISTRIBUTION_STATUS_COLORS: Record<
  DistributionStatus,
  'default' | 'secondary' | 'destructive' | 'outline' | 'success' | 'warning'
> = {
  [DistributionStatus.DRAFT]: 'secondary',
  [DistributionStatus.COMPLETED]: 'success',
  [DistributionStatus.CANCELLED]: 'destructive',
};

export function getAvailableActions(
  status: DistributionStatus
): DistributionAction[] {
  switch (status) {
    case DistributionStatus.DRAFT:
      return ['view_details', 'cancel'];
    case DistributionStatus.COMPLETED:
      return ['view_details', 'download_notices'];
    case DistributionStatus.CANCELLED:
      return ['view_details'];
    default:
      return ['view_details'];
  }
}
